import { useId, useState, type ReactNode } from 'react';

import './SummaryAccordion.scss';

interface ISummaryAccordionProps {
  title: ReactNode;
  value: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

const SummaryAccordion = ({ title, value, defaultOpen = false, children }: ISummaryAccordionProps) => {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();

  return (
    <div className="summary-accordion">
      <button
        type="button"
        className="summary-accordion__head"
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="summary-accordion__left">
          <svg
            className={['summary-accordion__caret', open ? 'summary-accordion__caret--open' : '']
              .filter(Boolean)
              .join(' ')}
            width="14"
            height="14"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M7 5l5 5-5 5"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="summary-accordion__title">{title}</span>
        </span>
        <span className="summary-accordion__value">{value}</span>
      </button>
      <div
        id={bodyId}
        hidden={!open}
        className={['summary-accordion__body', open ? 'summary-accordion__body--open' : ''].filter(Boolean).join(' ')}
      >
        {children}
      </div>
    </div>
  );
};

export default SummaryAccordion;
